import { APICaller } from "@api/request";
import { HTTPMethods } from "@enums/HttpMethods";
import { UserBody } from "@interfaces/User";
import { APIEndPoints } from "@api/endPoints";
import { RequestContentType } from "@enums/RequestContentType";
import GetDonations, { GetAbandonedDonations } from "@interfaces/GetDonations";
import GetUsers from "@interfaces/GetUsers";

export const createUser = async (body: FormData, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.UserCreate, HTTPMethods.POST, body, RequestContentType.FORM);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const getUserList = async (queryParams: GetUsers, APICaller: APICaller) => {
    const queryObject: Record<string, string> = {};
    if (queryParams.current_page_number) {
        queryObject.current_page_number = String(queryParams.current_page_number);
    }
    if (queryParams.item_per_page) {
        queryObject.item_per_page = String(queryParams.item_per_page);
    }
    if (queryParams.role) {
        queryObject.role = String(queryParams.role);
    }
    if (queryParams.search) {
        queryObject.search = String(queryParams.search);
    }
    if (queryParams.communication_preference) {
        queryObject.communication_preference = String(queryParams.communication_preference);
    }

    let query: string = new URLSearchParams(queryObject).toString();
    if (query.length > 0) {
        query = "?" + query;
    }
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.User + query, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const loginUser = async (body: UserBody, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.UserLogin, HTTPMethods.POST, body);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const userSignup = async (body: UserBody, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.UserSignup, HTTPMethods.POST, body);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const sendRequestToResetPassword = async (body: { email: string; forgotPasswordBaseUrl?: string }, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.ForgotPassword, HTTPMethods.POST, body);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const checkExpiryOfPasswordResetToken = async (body: { passwordResetToken: string }, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.VerifyPasswordResetToken, HTTPMethods.POST, body);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const getUserDetails = async (id: number, APICaller: APICaller) => {
    const url = APIEndPoints.UserDetails.replace("{0}", id.toString());
    const { jsonResponse } = await APICaller.validateAndCallAPI(url, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};


export const resetPassword = async (passwordResetToken: string, body: { password: string }, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.ResetPassword + "/" + passwordResetToken, HTTPMethods.PUT, body);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const verifyEmail = async (verificaitonToken: string, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.VerifyEmail.format(verificaitonToken), HTTPMethods.PUT);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

// export const updateUserDetails = async (id: number, body: FormData, APICaller: APICaller) => {
//     const url = APIEndPoints.UserDetails.format(id);  // Apply the format to include the id in the URL

//     const { jsonResponse } = await APICaller.validateAndCallAPI(url, HTTPMethods.POST, body, RequestContentType.FORM);

//     if (!jsonResponse.success) {
//         throw jsonResponse;
//     }

//     return jsonResponse;
// };

export const updateUserDetails = async (id: number, body: FormData, APICaller: APICaller) => {
    // Replace the placeholder {0} with the actual ID
    const url = APIEndPoints.UserDetails.replace("{0}", id.toString());

    console.log(url); // Verify the final URL

    const { jsonResponse } = await APICaller.validateAndCallAPI(url, HTTPMethods.POST, body, RequestContentType.FORM);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};




export const getUserDonationList = async (
    userId: number,
    queryParams: GetDonations,
    APICaller: APICaller
) => {
    const queryObject: Record<string, string> = {};
    if (queryParams.current_page_number) {
        queryObject.current_page_number = String(queryParams.current_page_number);
    }
    if (queryParams.item_per_page) {
        queryObject.item_per_page = String(queryParams.item_per_page);
    }
    if (queryParams.donation_type) {
        queryObject.donation_type = queryParams.donation_type;
    }
    if (queryParams.search_text) {
        queryObject.search_text = queryParams.search_text;
    }
    if (queryParams.campaign_slug) {
        queryObject.campaign_slug = queryParams.campaign_slug;
    }
    if (queryParams.min_amount !== undefined && queryParams.max_amount !== undefined) {
        queryObject.min_amount = String(queryParams.min_amount);
        queryObject.max_amount = String(queryParams.max_amount);
    }
    if (queryParams.start_date) {
        queryObject.start_date = String(queryParams.start_date);
    }
    if (queryParams.end_date) {
        queryObject.end_date = String(queryParams.end_date);
    }
    if (queryParams.payment_method) {
        queryObject.payment_method = String(queryParams.payment_method);
    }
    if (queryParams.status) {
        queryObject.status = String(queryParams.status);
    }

    let query: string = new URLSearchParams(queryObject).toString();
    if (query.length > 0) {
        query = "?" + query;
    }

    // ✅ Fix: Use .replace() to replace {0} with userId
    const url = APIEndPoints.UserDonations.replace("{0}", userId.toString()) + query;

    const { jsonResponse } = await APICaller.validateAndCallAPI(url, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const getUserAbandonedDonationList = async (userId: number, queryParams: GetAbandonedDonations, APICaller: APICaller) => {
    const queryObject: Record<string, string> = {};
    if (queryParams.current_page_number) {
        queryObject.current_page_number = String(queryParams.current_page_number);
    }
    if (queryParams.item_per_page) {
        queryObject.item_per_page = String(queryParams.item_per_page);
    }

    let query: string = new URLSearchParams(queryObject).toString();
    if (query.length > 0) {
        query = "?" + query;
    }

    // const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.UserAbandonedDonations.format(userId) + query, HTTPMethods.GET);
    const url = APIEndPoints.UserAbandonedDonations.replace("{0}", userId.toString()) + query;
    const { jsonResponse } = await APICaller.validateAndCallAPI(url, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

export const deleteUser = async (id: number, APICaller: APICaller) => {
    const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.User + "/" + id, HTTPMethods.DELETE);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }
    return jsonResponse;
};

// export const getDonationOverview = async (id: number, APICaller: APICaller) => {
//     const { jsonResponse } = await APICaller.validateAndCallAPI(APIEndPoints.UserDonationsOverview.format(id), HTTPMethods.GET);

//     if (!jsonResponse.success) {
//         throw jsonResponse;
//     }

//     return jsonResponse;
// };
export const getDonationOverview = async (id: number, APICaller: APICaller) => {
    const url = APIEndPoints.UserDonationsOverview.replace("{0}", id.toString()); // Replace placeholder with the actual id
    const { jsonResponse } = await APICaller.validateAndCallAPI(url, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

